<template>
  <div id="app2" ref="app2">
    <div class="page">
      <div class="page-container">
        <div :class="'player-container ' + link.theme">
          <div class="player-container-2">
            <template v-if="showYoutubePreview">
              <!-- <client-only>
                <LazyYoutube
                  ref="youtubeLazyVideo"
                  :src="link.tracks[0].url"
                  aspect-ratio="16:9"
                  thumbnail-quality="standard"
                  autoplay="true"
                />
              </client-only> -->
              <iframe
                :src="
                  link.tracks[0].url
                    .replace('youtu.be/', 'youtube.com/watch?v=')
                    .replace('youtube.com/shorts/', 'youtube.com/watch?v=')
                    .replace('watch?v=', 'embed/')
                    .split('&')[0]
                "
                width="340px"
                height="213px"
                style="border: 0;"
              >
              </iframe>
            </template>
            <template v-else-if="showImagePreview">
              <div :class="coverImageContainerClass">
                <img
                  :src="this.link.image"
                  v-if="coverImageStyle === 'square'"
                />
                <div
                  :style="{ ...playerBackgroundStyle, ...imgStyle }"
                  v-else
                ></div>
              </div>
            </template>
            <div v-else class="container-for-player">
              <div
                :style="playerBackgroundStyle"
                class="song-player-bg player-content dimmed"
              ></div>
              <div class="song-player player-content">
                <div v-if="showSpotifyOrCustomSongPreview" class="player">
                  <div>
                    <a
                      v-if="multipleTracks && playing"
                      id="prev-button"
                      class="player-button prev"
                      @click="playPrevious()"
                    >
                      <div class="prev-icon fa-layers">
                        <img src="/img/previous.svg" />
                      </div>
                    </a>
                  </div>
                  <a class="player-button pause" @click="pausePlay()">
                    <div v-if="playing" class="pause-icon fa-layers">
                      <img src="/img/pause.svg" />
                    </div>
                    <div v-else class="play-icon fa-layers">
                      <img src="/img/play.svg" />
                    </div>
                  </a>
                  <div>
                    <a
                      v-if="multipleTracks && playing"
                      id="next-button"
                      class="player-button next"
                      @click="playNext()"
                    >
                      <div class="next-icon fa-layers">
                        <img src="/img/next.svg" />
                      </div>
                    </a>
                  </div>
                  <span v-if="playing" class="player-progress-container">
                    <div class="player-progress"></div>
                    <div
                      :style="progressbarStyle"
                      class="player-progress-top-layer"
                    ></div>
                  </span>
                </div>
              </div>
            </div>
            <div>
              <div class="song-info">
                <h3
                  v-if="this.playing === false"
                  :class="{
                    'title-full': coverImageStyle === 'full',
                    'youtube-title-full': showYoutubePreview,
                  }"
                >
                  {{ !postRelease ? link.title : link.post_release_title }}
                </h3>
                <h3 v-else>
                  Playing: {{ link.tracks[this.currentTrackIndex].name }}
                </h3>
                <p
                  class="subtitle"
                  :class="{ 'subtitle-full': coverImageStyle === 'full' }"
                  v-if="link.subtitle.length"
                >
                  {{
                    !postRelease ? link.subtitle : link.post_release_subtitle
                  }}
                </p>
              </div>
              <div
                v-if="
                  link.artist &&
                    link.artist.socials &&
                    link.display_artist_socials &&
                    coverImageStyle === 'full'
                "
                class="socials socials-artist"
              >
                <a
                  v-for="social in link.artist.socials"
                  :key="social.id"
                  :href="social.url"
                >
                  <font-awesome-icon
                    :icon="getSocialIcon(social)"
                    :style="{ color: '#ffffff' }"
                  />
                </a>
              </div>
              <div class="countdown" v-if="preRelease && countdown.active">
                <div class="details">
                  <div class="el">
                    <div class="number">{{ countdown.days }}</div>
                    <div class="name">DAYS</div>
                  </div>
                  <div class="el">
                    <div class="number">{{ countdown.hours }}</div>
                    <div class="name">HOURS</div>
                  </div>
                  <div class="el">
                    <div class="number">{{ countdown.minutes }}</div>
                    <div class="name">MINUTES</div>
                  </div>
                  <div class="el">
                    <div class="number">{{ countdown.seconds }}</div>
                    <div class="name">SECONDS</div>
                  </div>
                </div>
                <div class="summary">Available {{ countdown.summary }}</div>
              </div>
              <ul
                v-if="
                  enabledDestinations.length && link.link_type === 'pre-release'
                "
                class="destinations"
              >
                <li
                  v-for="(destination, index) in enabledDestinations"
                  :key="index"
                >
                  <template v-if="destination.enabled">
                    <template v-if="destination.type === 'spotify'">
                      <div>
                        <div class="destination">
                          <img
                            :src="'/img/destinations_svg/spotify.svg'"
                            class="logo"
                            referrerpolicy="no-referrer"
                          />
                          <div class="name">
                            {{ destination.cta }}
                          </div>
                          <div class="arrow">
                            <font-awesome-icon :icon="['fas', 'arrow-right']" />
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-if="destination.type === 'applemusic'">
                      <div>
                        <div class="destination">
                          <img
                            :src="'/img/destinations_svg/applemusic.svg'"
                            class="logo"
                            referrerpolicy="no-referrer"
                          />
                          <div class="name">
                            {{ destination.cta }}
                          </div>
                          <div class="arrow">
                            <font-awesome-icon :icon="['fas', 'arrow-right']" />
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-if="destination.type === 'itunes'">
                      <div>
                        <div class="destination">
                          <img
                            :src="'/img/destinations_svg/itunes.svg'"
                            class="logo"
                            referrerpolicy="no-referrer"
                          />
                          <div class="name">
                            {{ destination.cta }}
                          </div>
                          <div class="arrow">
                            <font-awesome-icon :icon="['fas', 'arrow-right']" />
                          </div>
                        </div>
                      </div>
                    </template>
                    <div
                      v-if="destination.type === 'text'"
                      class="destination phone-number"
                    >
                      <div v-if="destination.text" class="ctap">
                        {{ destination.text }}
                      </div>
                      <div v-else class="ctap">
                        Notify me with a <strong>one-time</strong> message
                      </div>
                      <div class="tel-input">
                        <!-- <vue-tel-input mode="international" /> -->
                        <div class="flag">
                          <img
                            src="https://purecatamphetamine.github.io/country-flag-icons/3x2/US.svg"
                            alt=""
                          />
                        </div>
                        <div class="chevron">
                          <img
                            src="https://cdn3.iconfinder.com/data/icons/user-interface-169/32/chevron-bottom-1024.png"
                            alt=""
                          />
                        </div>
                        <div class="input">Your Number</div>
                        <div class="arrow">
                          <font-awesome-icon :icon="['fas', 'arrow-right']" />
                        </div>
                      </div>
                    </div>
                    <template v-if="destination.type === 'beatport'">
                      <div>
                        <div class="destination">
                          <img
                            :src="destination.logo"
                            class="logo"
                            referrerpolicy="no-referrer"
                          />
                          <div class="name">
                            {{ destination.cta }}
                          </div>
                          <div class="arrow">
                            <font-awesome-icon :icon="['fas', 'arrow-right']" />
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-if="destination.type === 'custom'">
                      <div>
                        <div class="destination">
                          <img
                            :src="destination.logo"
                            class="logo"
                            referrerpolicy="no-referrer"
                          />
                          <div class="name">
                            {{ destination.cta }}
                          </div>
                          <div class="arrow">
                            <font-awesome-icon :icon="['fas', 'arrow-right']" />
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>
                </li>
              </ul>
              <ul v-else-if="enabledDestinations.length" class="destinations">
                <template v-for="(destination, index) in enabledDestinations">
                  <template>
                    <li
                      :key="index"
                      :class="{
                        'header-container': destination.type === 'header',
                      }"
                    >
                      <div
                        v-if="destination.type === 'message_optin'"
                        class="destination phone-number"
                      >
                        <div class="cta-message-optin">
                          {{ destination.text }}
                        </div>
                        <div :class="'subscribe-input ' + link.theme">
                          <div
                            class="switch-input-preview"
                            v-if="
                              destination.config.phone_number_capture &&
                                destination.config.email_capture
                            "
                          >
                            <div
                              class="switch-input-icon"
                              v-if="destination.config.phone_number_capture"
                              :class="{ active: show === 'phone' }"
                              @click="show = 'phone'"
                            >
                              <font-awesome-icon :icon="['far', 'comment']" />
                            </div>
                            <div
                              class="switch-input-icon"
                              v-if="destination.config.email_capture"
                              :class="{ active: show === 'email' }"
                              @click="show = 'email'"
                            >
                              <font-awesome-icon :icon="['far', 'envelope']" />
                            </div>
                          </div>
                          <div class="email-input" v-show="show === 'email'">
                            <input
                              type="text"
                              name="email"
                              class="input"
                              placeholder="Your Email"
                            />
                            <div class="arrow">
                              <font-awesome-icon
                                :icon="['fas', 'arrow-right']"
                              />
                            </div>
                          </div>
                          <div class="tel-input" v-show="show === 'phone'">
                            <div class="flag">
                              <img
                                src="https://purecatamphetamine.github.io/country-flag-icons/3x2/US.svg"
                                alt=""
                              />
                            </div>
                            <div class="chevron">
                              <img
                                src="https://cdn3.iconfinder.com/data/icons/user-interface-169/32/chevron-bottom-1024.png"
                                alt=""
                              />
                            </div>
                            <div class="input">Your Number</div>
                            <div class="arrow">
                              <font-awesome-icon
                                :icon="['fas', 'arrow-right']"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        v-else-if="destination.type === 'header'"
                        class="destination header"
                      >
                        <div class="cta-message-optin">
                          {{ destination.text }}
                        </div>
                      </div>
                      <a v-else href="#" class="destination">
                        <div class="destination">
                          <template v-if="destination.icon_type == 'flat'">
                            <font-awesome-icon
                              :icon="['fab', destination.icon]"
                              :style="{
                                color: destination.icon_color,
                                margin: '16px',
                                width: '32px',
                                height: '32px',
                              }"
                            />
                          </template>
                          <template
                            v-else-if="destination.icon_type == 'emoji'"
                          >
                            <div class="emoji">{{ destination.icon }}</div>
                          </template>
                          <template v-else-if="destination.logo">
                            <img
                              :src="destination.logo"
                              class="logo"
                              referrerpolicy="no-referrer"
                            />
                          </template>
                          <template
                            v-else-if="
                              destination.type !== 'custom' &&
                                destination.icon_type !== 'none'
                            "
                          >
                            <img
                              :src="
                                '/img/destinations_svg/' +
                                  destination.type +
                                  '.svg'
                              "
                              class="logo"
                              referrerpolicy="no-referrer"
                            />
                          </template>
                          <template v-else>
                            <div
                              style="display: inline-block; width: 22px"
                            ></div>
                          </template>

                          <div v-if="destination.text" class="text">
                            {{ destination.text }}
                            <div class="description">
                              {{ destination.description }}
                            </div>
                          </div>
                          <div v-else class="name">
                            {{ destination.cta }}
                          </div>

                          <div class="arrow">
                            <font-awesome-icon
                              :icon="['fas', 'arrow-right']"
                              :style="{
                                color: isDarkTheme ? '#ffffff' : '#000000',
                              }"
                            />
                          </div>
                        </div>
                      </a>
                    </li>
                  </template>
                </template>
              </ul>
              <div
                v-if="
                  link.artist &&
                    link.artist.socials &&
                    link.display_artist_socials &&
                    coverImageStyle !== 'full'
                "
                class="socials"
              >
                <a
                  v-for="social in link.artist.socials"
                  :key="social.id"
                  :href="social.url"
                >
                  <font-awesome-icon
                    :icon="getSocialIcon(social)"
                    :style="{ color: '#ffffff' }"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="'background background-blur'"></div>
    </div>
  </div>
</template>

<script>
// https://jsfiddle.net/2ruff/pnb962o1/
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import duration from "dayjs/plugin/duration";

dayjs.extend(utc);
dayjs.extend(duration);

export default {
  name: "LandingPagePreviewTwo",
  props: ["link", "destinations", "preRelease", "postRelease"],
  components: {},
  data() {
    return {
      countdown: {},
      show: "phone",
      audio: null,
      playing: false,
      paused: false,
      currentTrackIndex: 0,
      currentTrackLength: 0,
      currentTrackPercent: 0,
    };
  },
  mounted() {
    this.$refs.app2.style.background = "#525252";
    this.$refs.app2.style.backgroundPosition = "center";
    this.$refs.app2.style.backgroundImage = `url("${this.link.image}")`;
    this.$refs.app2.style.backgroundRepeat = "no-repeat";
    this.$refs.app2.style.backgroundSize = "cover";
  },
  computed: {
    isDarkTheme() {
      return this.link.theme === "dark";
    },
    enabledDestinations() {
      return this.destinations.filter((x) => x.enabled === true);
    },
    playerBackgroundStyle() {
      return {
        backgroundImage: `url("${this.link.image}"`,
      };
    },
    progressbarStyle() {
      return {
        width: this.currentTrackPercent + "%",
      };
    },
    multipleTracks() {
      return this.link.tracks.length > 1;
    },
    showImagePreview() {
      return this.link.preview_type === "image" && this.link.image;
    },
    showYoutubePreview() {
      return this.link.preview_type === "youtube" && this.link?.tracks[0]?.url;
    },
    showSpotifyOrCustomSongPreview() {
      if (this.link.preview_type === "spotify") return true;
      return this.link.preview_type === "custom" && this.link?.tracks[0]?.url;
    },
    linkType() {
      return this.link.type || this.link.link_type;
    },
    coverImageStyle() {
      return this.link.cover_image_style;
    },
    pageContainerFullMobile() {
      return this.coverImageStyle === "full" && this.$device.isMobile;
    },
    coverImageContainerClass() {
      return {
        "full-cover-container": this.coverImageStyle === "full",
        "square-cover-container": this.coverImageStyle === "square",
      };
    },
    imgStyle() {
      const style = {
        margin: "30px auto 0",
        boxShadow:
          "0 13px 27px -5px rgb(0 0 0 / 25%), 0 8px 16px -8px rgb(0 0 0 / 30%)",
        backgroundSize: "cover",
      };

      if (this.coverImageStyle === "full") {
        return {
          ...style,
          borderRadius: "0",
          height: "340px",
          width: "100%",
          margin: "0 auto 15px",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center"
        };
      } else if (this.coverImageStyle === "avatar") {
        return {
          ...style,
          borderRadius: "100px",
          height: "150px",
          width: "150px",
        };
      }

      return {};
    },
  },
  watch: {
    destinations: {
      handler: function() {
        const messageOptin = this.destinations.find(
          (x) => x.type === "message_optin"
        );

        if (!messageOptin) return;

        if (
          !messageOptin.config.phone_number_capture &&
          this.show === "phone"
        ) {
          this.show = "email";
        } else if (
          !messageOptin.config.email_capture &&
          this.show === "email"
        ) {
          this.show = "phone";
        }
      },
      deep: true,
    },
  },
  created() {
    const vm = this;
    setInterval(function() {
      const m = dayjs(vm.link.release_time);
      const now = dayjs();

      const ms = dayjs(m, "DD/MM/YYYY HH:mm:ss")
        .utcOffset(0)
        .diff(dayjs(now, "DD/MM/YYYY HH:mm:ss"));
      const d = dayjs.duration(ms);
      const s = Math.floor(d.asHours()) + dayjs.utc(ms).format(":mm:ss");

      const [hours, minutes, seconds] = s.split(":");

      vm.countdown = {
        summary: m.format("dddd, MMMM D YYYY"),
        days: Math.floor(hours / 24),
        hours: Math.ceil(hours % 24),
        minutes: Math.ceil(minutes),
        seconds: Math.ceil(seconds),
        active: ms > 0,
      };
    }, 1000);
  },
  methods: {
    getSocialIcon(social) {
      if (social.type === "website") {
        return ["fas", "globe"];
      } else {
        return ["fab", social.type];
      }
    },
    getDurationSeconds(length) {
      const tt = length.split(":").reverse();
      return (
        (tt.length >= 3 ? +tt[2] : 0) * 60 * 60 +
        (tt.length >= 2 ? +tt[1] : 0) * 60 +
        (tt.length >= 1 ? +tt[0] : 0)
      );
    },
    getPlayPercent() {
      return this.audio.currentTime / 30;
      // return this.audio.currentTime / this.currentTrackLength;
    },
    play() {
      // this.playing = true;
      // if (this.paused) {
      //   this.paused = false;
      //   return this.audio.play();
      // }
      // const track = this.link.tracks[this.currentTrackIndex];
      // this.currentTrackLength = 30; // TODO: check: this.getDurationSeconds(track.length);
      // this.audio = new Audio(track.url);
      // this.audio.ontimeupdate = () => {
      //   this.currentTrackPercent = this.getPlayPercent() * 100;
      // };
      // this.audio.onended = () => {
      //   this.playing = false;
      //   this.paused = false;
      //   if (this.link.tracks.length > 1) this.playNext();
      // };
      // this.audio.play();
    },
    pause() {
      this.playing = false;
      this.paused = true;
      this.audio.pause();
    },
    pausePlay() {
      if (this.playing) {
        this.pause();
      } else {
        this.play();
      }
    },
    playNext() {
      if (this.currentTrackIndex < this.link.tracks.length - 1) {
        this.currentTrackIndex++;
      } else {
        this.currentTrackIndex = 0;
      }
      this.audio.pause();
      this.play();
    },
    playPrevious() {
      if (this.currentTrackIndex > 0) {
        this.currentTrackIndex--;
      } else {
        this.currentTrackIndex = this.link.tracks.length - 1;
      }
      this.audio.pause();
      this.play();
    },
  },
};
</script>

<style scoped>
#app2 {
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  /*font-size: 16px;*/
  /*word-spacing: 1px;*/
  /*-ms-text-size-adjust: 100%;*/
  /*-webkit-text-size-adjust: 100%;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*box-sizing: border-box;*/
  /*position: relative;*/
  /*min-height: 100%;*/
  /*height: auto;*/
  /*width: 100%;*/
  /*display: flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
}
*,
:after,
:before {
  box-sizing: border-box;
  margin: 0;
}
.page {
  width: 100%;
  height: 100%;
  position: relative;
}

.background {
  position: absolute;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
  background-position: bottom;
  /* background-size: cover; */
  height: 100%;
  width: 100%;
}
.light .background-blur {
  background: #0000007d;
}
.dark .background-blur {
  background: #0000007d;
}
.background-blur {
  backdrop-filter: blur(50px);
  height: 100%;
}

.background-gradient {
  background-image: linear-gradient(rgb(255 255 255 / 0%) 0%, #222 100%);
  background-attachment: fixed;
  background-repeat: no-repeat;
}

.dark {
  color: #fff;
}
.light {
  color: #000;
}

/* Page */
.page-container {
  margin: auto;
  background: rgba(255, 255, 255, 0.09);
}
.player-container {
  z-index: 10;
  position: relative;
  aspect-ratio: 253 / 498;
  max-width: 100%;
}
.player-container-2 {
  overflow-y: auto;
  z-index: 10;
  position: relative;
  width: 100%;
  height: 100%;
  padding: 1px 0;
  background: #0000007d;
}
.page-background {
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0;
  right: 0px;
  overflow: hidden;
}
.page-background.dark {
  background-color: black;
}
.page-background img {
  filter: blur(50px);
  transform: scale(1.2);
  display: block;
  width: 100vw;
  height: 100vh;
  object-fit: cover;
}
.container-for-player {
  height: 240px;
  display: block;
  position: relative;
  width: 240px;
  margin: 50px 50px 10px;
}
.song-player-bg.dimmed {
  transition: all 1s ease;
}
.song-player-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  box-shadow: none;
  position: relative;
  transition: all 1s ease;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
  border-radius: 2px;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 13px 27px -5px,
    rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
}
.player-content {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.song-player {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  transition: opacity 0.7s ease-in;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
.player {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.player-button {
  transition: all 0.25s ease;
  display: block;
  border: 2px solid #fff;
  cursor: pointer;
  user-select: none;
}
.play.player-button,
.pause.player-button,
.prev.player-button,
.next.player-button {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.55);
  border-radius: 60px;
  position: relative;
}
.play.player-button,
.pause.player-button {
  height: 100px;
  width: 100px;
  margin: 0 20px;
}
.prev.player-button,
.next.player-button {
  height: 50px;
  width: 50px;
}
.pause-icon,
.play-icon {
  font-size: 40px;
  color: #fff;
}
.prev-icon,
.next-icon {
  font-size: 20px;
  color: #fff;
}
.player-button {
  background-position: center;
  transition: background 0.8s;
}
.player-button:hover {
  background: rgba(0, 0, 0, 0.75)
    radial-gradient(circle, transparent 1%, #000000 1%) center/15000%;
}
.player-button:active {
  background-color: rgba(0, 0, 0, 0.55);
  background-size: 100%;
  transition: background 0s;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
span.player-progress-container {
  width: 100%;
}
.player-progress {
  width: 100%;
  background: #000;
  background: rgba(0, 0, 0, 0.55);
}
.player-progress-top-layer {
  background: #fff;
  background: rgba(255, 255, 255, 0.8);
  width: 0;
  left: 0;
}
span.player-progress-container,
.player-progress,
.player-progress-top-layer {
  height: 6px;
  position: absolute;
  bottom: 0;
}
.square-cover-container {
  display: block;
  position: relative;
  width: calc(100% - 100px);
  margin: 50px 50px 10px;
}
.square-cover-container img {
  width: 100%;
  border-radius: 3px;
}
.song-info {
  -webkit-filter: drop-shadow(0 0 10px rgba(0, 0, 0, 0.3));
  filter: drop-shadow(0 0 10px rgba(0, 0, 0, 0.3));
  padding: 15px;
  width: 100%;
  color: #ffffff;
  color: #ffffffe0;
}
.song-info {
  text-align: center;
}
.song-info h3 {
  font-size: 18px;
  font-weight: 500;
}
.full-cover-container {
  mask-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 1) 50%,
    transparent 100%
  );
}
.title-full {
  font-weight: 700 !important;
  font-size: 42px !important;
  margin-top: -50px;
}
.youtube-title-full {
  margin-top: 15px;
}
.subtitle-full {
  margin: 15px 0 !important;
}
.song-info p {
  margin-top: 20px;
}
.song-info h4,
.song-info p {
  text-overflow: ellipsis;
  overflow: hidden;
}
.subtitle {
  font-size: 14px;
  font-weight: 300;
}

.countdown {
  margin: 8px 0 20px;
  color: #ffffff;
  color: #ffffffe0;
}
.countdown .details {
  display: flex;
  justify-content: space-around;
  margin-bottom: 15px;
}
.countdown .el {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.countdown .el .number {
  font-weight: 700;
  font-size: 15px;
  line-height: 21px;
}
.countdown .el .name {
  margin-top: 10px;
  font-weight: 300;
  font-size: 10px;
  line-height: 15px;
}
.countdown .summary {
  margin-bottom: 10px;
  text-align: center;
  font-size: 14px;
}

/* Destinations */
ul.destinations {
  padding: 0;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  transition: all 0.6s ease-in-out;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}
ul.destinations li {
  list-style: none;
  transition: 0.3s;
  margin: 12px;
  border-radius: 11px;
  padding: 1px;
  transition: 0.3s;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px,
    rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
}
ul.destinations li:hover,
ul.destinations li:active {
  transform: scale(1.03);
}
.dark ul.destinations li {
  background: #111111;
  background: #111111f3;
  color: #fff;
}
.dark ul.destinations li:hover {
  background: #111111;
}
.dark ul.destinations li a {
  color: #fff;
}
.light ul.destinations li {
  background: #ffffff;
  background: #fffffff3;
  color: #000;
}
.light ul.destinations li:hover {
  background: #ffffff;
}
.light ul.destinations li a {
  color: #000;
}
ul.destinations li div.destination {
  min-height: 40px;
  transition: all 0.6s ease-in-out;
  overflow: hidden;
  display: flex;
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  background: transparent;
  width: 100%;
  border: none;
  font-weight: 600;
}
ul.destinations li div.destination .logo {
  height: 50px;
  width: 50px;
  float: left;
  padding: 3px;
  border-radius: 10px;
}
div.destination .name {
  margin-left: 10px;
  text-decoration: none;
  font-size: 15px;
}
li:hover .name {
  font-weight: inherit;
}
.arrow {
  font-size: 13px;
  margin-left: auto;
  margin-right: 22px;
}
.check-container {
  width: 17px;
  height: 17px;
  font-size: 10px;
  margin-left: auto;
  margin-right: 22px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.light .check-container {
  background: #fff;
  color: #000;
}
.dark .check-container {
  background: #000;
  color: #fff;
}
.text {
  margin-left: 10px;
  font-size: 15px;
  text-decoration: none;
  display: inline-block;
  padding-right: 16px;
}
.text .description {
  font-size: 12px;
  margin-top: 5px;
  font-weight: 300;
}
.dark .header-container {
  color: #111111 !important;
}
.light .header-container {
  color: #ffffff !important;
}
.header-container {
  /* background: #0000004a !important; */
  background: transparent !important;
  box-shadow: none !important;
}
.header {
  flex-direction: column;
  align-items: flex-start !important;
  padding: 15px 19px;
  overflow: visible !important;
  cursor: auto !important;
}
.phone-number {
  flex-direction: column;
  align-items: flex-start !important;
  padding: 15px 19px;
  overflow: visible !important;
  cursor: auto !important;
}
.phone-number .arrow {
  margin-right: 0;
  cursor: pointer;
}
.light .phone-number:hover {
  background-color: #fff !important;
}
.dark .phone-number:hover {
  background-color: #000 !important;
}
.phone-number .ctap {
  flex-direction: column;
  font-size: 15px;
}
.tel-input {
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 12px;
  display: flex;
  align-items: center;
  padding-right: 11px;
  width: 100%;
  margin-top: 9px;
}
.flag img {
  width: 25px;
  margin: 8px;
}
.chevron img {
  width: 14px;
  margin-right: 10px;
}
.dark .chevron img {
  filter: invert(100%);
}
.tel-input .input {
  color: #8f8f8f;
  font-size: 15px;
  font-weight: 400;
}
.light .tel-input {
  border-color: #aaa;
}
.right .details {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.socials {
  display: flex;
  justify-content: center;
}
.socials a {
  color: #ccc;
  margin: 8px;
  font-size: 28px;
}
.socials a:hover {
  color: white;
}
.socials-artist {
  margin-top: 0;
  margin-bottom: 40px;
}
.socials a {
  margin: 8px 16px;
  font-size: 24px;
}
.footer {
  text-align: center;
  width: 330px;
  font-weight: 400;
  font-size: 11px;
  line-height: 24px;
  margin: 15px auto;
  color: #eee;
  position: relative;
  text-shadow: 0px 1px 2px rgb(0 0 0 / 28%);
}
.footer a {
  font-weight: bold;
  cursor: pointer;
  color: #fff;
}
.powered-wrapper {
  text-align: center;
}
.powered {
  padding: 5px 10px;
  border-radius: 2px;
  color: #fff;
  font-size: 10px;
  text-align: center;
  display: inline-block;
  margin-bottom: 15px;
  transition: 0.3s;
  text-transform: uppercase;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.powered:hover {
  background: #eee;
  color: #222;
}
a {
  text-decoration: none;
}
.privacy-policy {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1;
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  color: #ccc;
  padding-left: 20px;
}
@media only screen and (max-width: 600px) {
  .privacy-policy {
    position: relative;
    text-align: center;
    padding-left: 0;
  }
}

/* email opt-in */
.email-optin {
  padding: 10px 20px 15px;
}
.email-optin .stay-notified label {
  font-size: 12px;
  font-weight: bold;
}
.email-optin .stay-notified .description {
  font-size: 12px;
}
.email-optin .email-form {
  display: flex;
  padding-top: 10px;
}
.email-optin .email-form input {
  flex: 1;
  padding: 5px 10px;
  border: 1px solid #e1e1e4;
  background-color: transparent;
  border-radius: 4px 0 0 4px;
}
.light .email-optin .email-form input {
  border: 1.2px solid #222;
}
.dark .email-optin .email-form input {
  color: #fff;
  border: 1.2px solid #fff;
}
.email-optin .email-form button {
  padding: 10px 7px;
  text-align: center;
  border-radius: 0 4px 4px 0;
  margin-left: -1px;
  float: right;
  font-size: 13px;
  width: 100px;
  transition: 0.3s;
  cursor: pointer;
  background-color: transparent;
  font-weight: bold;
}
.light .email-optin .email-form button {
  color: #414754;
  border: 1.2px solid #222;
}
.dark .email-optin .email-form button {
  color: #fff;
  border: 1.2px solid #fff;
}
.email-optin .email-form button:hover {
  font-weight: inherit;
}
.light .email-optin .email-form button:hover {
  color: #fff;
  background: #2b2b2b;
  border-color: #2b2b2b;
}
.dark .email-optin .email-form button:hover {
  color: #2b2b2b;
  background: #fff;
  border-color: #fff;
}

.subscription-result {
  font-size: 12px;
  margin-top: 5px;
}
.subscription-result .success {
  color: #0f790f;
}
.subscription-result .fail {
  color: #ea0101;
}

.emoji {
  padding: 10px 0;
  font-size: 32px;
  position: relative;
  width: 60px;
  align-items: center;
  justify-content: center;
  display: inherit;
}

.subscribe-input {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.subscribe-input .switch-text {
  font-size: 1.2rem;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
}
.subscribe-input .switch-input-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 5px 20px 0;
  box-sizing: border-box;
}
.dark.subscribe-input .switch-input .switch-input-icon {
  color: #fff;
}
.light.subscribe-input .switch-input .switch-input-icon {
  color: #111;
}

.subscribe-input .switch-input-preview .switch-input-icon {
  margin: 0 5px;
  font-size: 1.5rem;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.subscribe-input .switch-input-preview .switch-input-icon:hover {
  background: #c2c2c2;
}
.dark.subscribe-input .switch-input .active {
  background: #ffffff !important;
  color: #111111 !important;
}
.light.subscribe-input .switch-input .active {
  background: #111111 !important;
  color: #ffffff !important;
}
.email-input {
  border: 1px solid rgba(203, 203, 203, 0.6);
  border-radius: 12px;
  display: flex;
  align-items: center;
  padding-right: 11px;
  width: 100%;
  margin-top: 9px !important;
}
.dark .email-input input {
  color: #ffffff;
}
.light .email-input input {
  color: #111111;
}
.email-input input {
  width: 100%;
  height: 36px;
  padding-left: 14px;
  border-width: 0;
  font-size: 15px;
  color: #5f5f61;
  background: transparent;
}
.email-input input:focus {
  outline-width: 0;
}
.email-input .arrow {
  margin-right: 0;
  font-size: 13px;
  color: #555;
  cursor: pointer;
}
.email-input.active .arrow {
  margin-right: -7px;
  height: 30px;
  width: 30px;
  line-height: 30px;
  padding: 0;
  border-radius: 100%;
  text-align: center;
}
.dark .email-input.active .arrow {
  background: #ffffff;
}
.light .email-input.active .arrow {
  color: #111;
}
.email-input .arrow img {
  width: 13px;
}
.cta-message-optin {
  font-size: 15px;
  text-align: center;
  width: 100%;
}
</style>
